import { readToken } from './token'

type UseTokenExpiryResult = {
  shouldShowExpiryWarning: boolean
  expiresAt: number | null
  timeUntilExpiry: number | null
}

const ONE_HOUR_IN_SECONDS = 60 * 60

export function useTokenExpiry(warningThresholdSeconds: number = ONE_HOUR_IN_SECONDS): UseTokenExpiryResult {
  const token = readToken()

  if (!token || !token.refreshTokenExpiration) {
    return {
      shouldShowExpiryWarning: false,
      expiresAt: null,
      timeUntilExpiry: null,
    }
  }

  const now = Math.floor(Date.now() / 1000)
  const timeUntilExpiry = token.refreshTokenExpiration - now
  const expiresAt = token.refreshTokenExpiration * 1000

  const shouldShowExpiryWarning = timeUntilExpiry > 0 && timeUntilExpiry < warningThresholdSeconds

  return {
    shouldShowExpiryWarning,
    expiresAt,
    timeUntilExpiry,
  }
}
